export interface IPassOption {
  id: string;
  label: string | null;
  price: number;
  sortOrder: number;
}

export enum PassCategory {
  Contractor = 'Contractor',
  Resident = 'Resident',
  Member = 'Member',
}

export interface IPass {
  id: string;
  name: string;
  description: string | null;
  category: PassCategory;
  options: IPassOption[];
}

export enum PaymentMethod {
  Card = 'card',
  Cash = 'cash',
}

export interface ICheckoutForm {
  firstName: string;
  lastName: string;
  company: string;
  email: string;
  licensePlate: string;
  state: string;
}
